import { takeEvery, put, select } from "redux-saga/effects";
import * as types from "./enderecoCobranca.actionTypes";
import enderecoPrincipalSelector from "@/modules/deca/components/enderecoPrincipal/store/enderecoPrincipal.selectors";
import enderecoCobrancaSelector from "./enderecoCobranca.selectors";
import enderecoCobrancaActions from "./enderecoCobranca.actions";

export default workSaga;

function* workSaga() {
  yield takeEvery(
    types.GET_DADOS_ENDERECO_PRINCIPAL,
    getDadosEnderecoPrincipal
  );
}

function* getDadosEnderecoPrincipal() {
  const enderecoPrincipal = yield select(
    enderecoPrincipalSelector.enderecoPrincipal
  );
  const enderecoCobranca = yield select(
    enderecoCobrancaSelector.enderecoCobranca
  );

  const existeEnderecoPrincipal = yield filledCep(enderecoPrincipal.Cep);
  const existeEnderecoCobranca = yield filledCep(enderecoCobranca.Cep);

  if (existeEnderecoPrincipal && !existeEnderecoCobranca) {
    let result = yield _alert.confirm(
      "Deseja aplicar as informações do Endereço da Atividade no Endereço de Cobrança?"
    );

    if (result) {
      yield put(enderecoCobrancaActions.setEnderecoCobranca(enderecoPrincipal));
    }
  }
}

function* filledCep(address) {
  return address && !address.includes("_");
}
